import { apiRequest } from "./client";

export interface AuditEntry {
  id: number;
  actor_user_id: number | null;
  actor_login: string | null;
  actor_full_name: string | null;
  action: string;
  entity_type: string | null;
  entity_id: number | null;
  payload: Record<string, unknown>;
  ip: string | null;
  user_agent: string | null;
  created_at: string;
}

export interface AuditList {
  items: AuditEntry[];
  total: number;
  page: number;
  page_size: number;
}

export interface AuditFilters {
  actor_user_id?: number;
  entity_type?: string;
  action?: string;
  q?: string;
  page?: number;
  page_size?: number;
}

export function listAudit(filters: AuditFilters = {}): Promise<AuditList> {
  const u = new URLSearchParams();
  if (filters.actor_user_id) u.set("actor_user_id", String(filters.actor_user_id));
  if (filters.entity_type) u.set("entity_type", filters.entity_type);
  if (filters.action) u.set("action", filters.action);
  if (filters.q) u.set("q", filters.q);
  if (filters.page) u.set("page", String(filters.page));
  if (filters.page_size) u.set("page_size", String(filters.page_size));
  const s = u.toString();
  return apiRequest<AuditList>(`/audit${s ? `?${s}` : ""}`);
}
